var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 50,
    viewBox: "0 0 68 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 50,
    fill: "#06EFC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1667 20.625L29 25M29 25L33.1667 29.375M29 25L39 25",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLeftArrow);
export default __webpack_public_path__ + "static/media/sliderLeftArrow.fe1901020fac0245b58f2c41c48ffb7a.svg";
export { ForwardRef as ReactComponent };